import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVGInline from "react-svg-inline";

// icons
import crossSVG from "../../inlineSVGs/crossSVG";

// styles
import './CollapsibleInfo.css';
import plusSVG from "../../inlineSVGs/plusSVG";

class CollapsibleInfo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        }
    }

    render() {

        return (
            <div className="collapsible-info-wrapper" onClick={() => this.setState({ isOpen: !this.state.isOpen})}>
                <div className="ci-title-wrapper">
                    <div className="ci-title">{this.props.title}</div>
                    <SVGInline className={`ci-open-close-icon ${this.state.isOpen ? 'opened' : ''}`} svg={plusSVG} component="i"/>
                </div>
                <div className="ci-extended-container">
                    <div className={`ci-extended-area ${this.state.isOpen ? 'opened' : ''}`}>
                        <p className={`ci-text`}>{this.props.text}</p>
                    </div>
                </div>
            </div>
        )
    }
}

CollapsibleInfo.propTypes = {
    isOpenGlobal: PropTypes.bool,
    title: PropTypes.string,
    text: PropTypes.string
};

export default CollapsibleInfo;



// WEBPACK FOOTER //
// ./src/Components/Elements/Collapsiblenfo/CollapsibleInfo.js